// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_79y","clinicsSelect":"styles_clinicsSelect__3gwC4"};